module.exports = __webpack_public_path__ + "img/kontakt_b.bae67b98.svg";